import {createRouter, createWebHistory} from 'vue-router'
import {createRouterLayout} from 'vue-router-layout'
import {middleware} from "vue-router-middleware";

import "./middleware/require-auth";
import "./middleware/redirect-to-login";
import "./middleware/redirect-with-not-found";
import "./middleware/require-without-auth";

import Login from "@/views/LoginView.vue";
import UsersView from "@/views/users/UsersView.vue";
import ProfileVIew from "@/views/ProfileVIew.vue";
import EditUserView from "@/views/users/EditUserView.vue";
import CreateUserView from "@/views/users/CreateUserView.vue";
import StateConstructorView from "@/views/state-constructor/StateConstructorView.vue";
import CounterpartiesView from "@/views/counterparties/CounterpartiesView";
import CreateCounterpartyView from "@/views/counterparties/CreateCounterpartyView";
import NotificationsView from "@/views/notifications/NotificationsView";
import NotificationView from "@/views/notifications/NotificationView";
import NoticesView from "@/views/notices/NoticesView";
import RolesView from "@/views/roles/RolesView";
import TariffsView from "@/views/tariffs/TariffsView";
import ReviewsView from "@/views/reviews/ReviewsView";
import BuildingsView from "@/views/buildings/BuildingsView";
import ServicesVIew from "@/views/services/ServicesVIew";
import ServicesListView from "@/views/services/ServicesListView";
import ServiceCategoriesView from "@/views/services/ServiceCategoriesView";
import UpdateReviewView from "@/views/reviews/UpdateReviewView";
import EditTariffView from "@/views/tariffs/EditTariffView";
import CreateTariffView from "@/views/tariffs/CreateTariffView.vue";
import EditNoticeVIew from "@/views/notices/EditNoticeVIew.vue";
import CreateNoticeView from "@/views/notices/CreateNoticeView.vue";
import ObjectsView from "@/views/objects/ObjectsView";
import SupportView from "@/views/SupportView";
import VendorsView from "@/views/vendors/VendorsView";
import VendorsListView from "@/views/vendors/VendorsListView";
import BanksListView from "@/views/vendors/BanksListView";
import VendorView from "@/views/vendors/VendorView";
import CreateAcquiringView from "@/views/vendors/CreateAcquiringView";
import PartnersView from "@/views/partners/PartnersView";
import PartnersListView from "@/views/partners/PartnersListView";
import PartnerCategoriesView from "@/views/partners/PartnerCategoriesView";
import PartnerCreateView from "@/views/partners/CreatePartnerView.vue";
import ServiceView from "@/views/services/ServiceView.vue";
import PartnerView from "@/views/partners/PartnerView";
import PartnerCategoryView from "@/views/partners/PartnerCategoryView";
import ServiceCategory from "@/views/services/ServiceCategory";
import CreateServiceCategory from "@/views/services/CreateServiceCategory";
import CreateVendorView from "@/views/vendors/CreateVendorView";
import CreateBuildingView from "@/views/buildings/CreateBuildingView";
import NotFound from "@/views/NotFound.vue";
import BuildingView from "@/views/buildings/BuildingView.vue";
import BuildingPointsView from "@/views/buildings/BuildingLocationPointsView.vue";
import CreateServiceView from "@/views/services/CreateServiceView.vue";
import CategoriesSegmentView from "@/views/buildings/CategoriesSegmentView.vue";
import ObjectView from "@/views/objects/ObjectView.vue";
import CreateLocationPointView from "@/views/buildings/CreateLocationPointView.vue";
import CategorySegmentView from "@/views/buildings/CategorySegmentView.vue";
import CounterpartyView from "@/views/counterparties/CounterpartyView.vue";
import CreateBuildingSegmentView from "@/views/buildings/CreateBuildingSegmentView";
import CreatePartnerCategory from "@/views/partners/CreatePartnerCategory.vue";
import WebsiteView from "@/views/website/WebsiteView.vue";
import CreateWebsiteNews from "@/views/websiteNews/CreateWebsiteNews.vue";
import CreateWebsiteServices from "@/views/websiteService/CreateWebsiteSevice.vue";
import WebsiteInfrastructure from "@/views/websiteInfrastructure/WebsiteInfrastructure.vue";
import WebsiteInfrastructureCategory from "@/views/websiteInfrastructure/WebsiteInfrastructureCategory.vue";
import PersonalAccounts from "@/views/personalAccounts/PersonalAccounts.vue";
import ThroughBlocksView from "@/views/through-blocks/ThroughBlocksView.vue";
import PolicyView from "@/views/policy/PolicyView.vue";
import PaymentsView from "@/views/payments/PaymentsView.vue";
import ErrorView from '@/views/errorView/ErrorView.vue'
import SettingsView from '@/views/settings/SettingsView.vue'
import ModalsItemView from '@/views/settings/ModalsItemView.vue'
import HintsItemView from '@/views/settings/HintsItemView.vue'
import InfoPageView from '@/views/settings/InfoPageView.vue'
import PromosView from '@/views/promos/PromosView.vue'
import GeoRestrictionsView from '@/views/promos/GeoRestrictionsPage.vue'
import VacanciesLocations from '@/views/vacancies/VacanciesLocations.vue'
import VacanciesDepartments from '@/views/vacancies/VacanciesDepartments.vue'
import VacanciesItem from '@/views/vacancies/VacanciesItem.vue'
import ReportsView from '@/views/reports/ReportsView.vue'

console.log(...middleware('require-auth', [{}]))

const RouterLayout = createRouterLayout(layout => {
    return import('@/layouts/' + layout + '.vue')
});

const routes = [
    {
        path: '/:catchAll(.*)',
        name: '/error'
    },
    {
        path: '/',
        name: 'base',
        component: RouterLayout,
        children: [
            {
                path: 'login',
                name: 'login',
                component: Login,
            },
            ...middleware('require-auth', [{
                path: 'notifications',
                name: 'notifications',
                component: NotificationsView,
            }, {
                path: 'notifications/:id',
                name: 'notification-view',
                component: NotificationView,
            },{
                path: 'error',
                name: 'error',
                component: ErrorView,
            }, {
                path: 'rights',
                name: 'rights',
                component: RolesView
            },{
                path: 'promos',
                name: 'promos',
                component: PromosView
            },{
                path: 'geo-restrictions',
                name: 'geo-restrictions',
                component: GeoRestrictionsView
            }, {
                path: 'notices',
                name: 'notices',
                component: NoticesView
            }, {
                path: 'notices/:id',
                name: 'notice-view',
                component: EditNoticeVIew,
            }, {
                path: 'notices/create',
                name: 'notice-create',
                component: CreateNoticeView,
            }, {
                path: 'reviews',
                name: 'reviews',
                component: ReviewsView,
            }, {
                path: 'policy',
                name: 'policy',
                component: PolicyView,
            },
            {
                path: 'payments',
                name: 'payments',
                component: PaymentsView,
            }, {
                path: 'blocks',
                name: 'blocks',
                component: ThroughBlocksView
            }, {
                    path: 'reviews/:id',
                    name: 'review-view',
                    component: UpdateReviewView
            },
                {
                path: 'services/:id',
                name: 'service-view',
                component: ServiceView
            }, {
                path: 'services',
                name: 'services',
                component: ServicesVIew,
                children: [{
                    path: 'categories',
                    name: 'service-categories',
                    component: ServiceCategoriesView,
                }, {
                    path: 'list/:type',
                    name: 'services-list',
                    component: ServicesListView
                },]
            },  {
                path: 'services/categories/:id',
                name: 'service-category',
                component: ServiceCategory
            }, {
                path: 'services/categories/create',
                name: 'create-service-category',
                component: CreateServiceCategory,
            }, {
                path: 'services/create',
                name: 'create-service',
                component: CreateServiceView
            }, {
                path: 'buildings',
                name: 'buildings',
                component: BuildingsView,
            }, {
                path: 'buildings/create',
                name: 'create-building',
                component: CreateBuildingView
            }, {
                path: 'buildings/:id',
                name: 'building-edit',
                component: BuildingView,
            }, {
                path: 'buildings/:id/segments/:segment',
                name: 'building-segment-edit',
                component: CategoriesSegmentView,
            }, {
                path: 'buildings/:id/segments/create',
                name: 'building-segment-create',
                component: CreateBuildingSegmentView
            }, {
                path: 'buildings/:id/locations/points',
                name: 'building-locations-points-edit',
                component: BuildingPointsView
            }, {
                path: 'buildings/:id/attractions/points',
                name: 'building-attractions-points-edit',
                component: BuildingPointsView
            }, {
                path: 'buildings/:id/attractions/points/create',
                name: 'building-attractions-points-create',
                component: CreateLocationPointView
            }, {
                path: 'buildings/:id/locations/points/create',
                name: 'building-locations-points-create',
                component: CreateLocationPointView
            }, {
                path: 'buildings/:id/segments/:segmentId/categories/:categoryId',
                name: 'building-room-categories-view',
                component: CategorySegmentView
            },{
                path: 'users',
                name: 'users',
                component: UsersView
            }, {
                path: 'users/:id/edit',
                name: 'user-edit',
                component: EditUserView,
            }, {
                path: 'users/create',
                name: 'user-create',
                component: CreateUserView,
            }, {
                path: 'tariffs',
                name: 'tariffs',
                component: TariffsView,
            }, {
                path: 'tariffs/create',
                name: 'tariff-create',
                component: CreateTariffView,
            }, {
                path: '/tariffs/:id',
                name: 'tariff-view',
                component: EditTariffView
            }, {
                path: 'vendors',
                name: 'vendors',
                component: VendorsView,
                children: [{
                    path: 'list',
                    name: 'vendors-list',
                    component: VendorsListView
                }, {
                    path: 'banks',
                    name: 'vendors-banks',
                    component: BanksListView
                }]
            }, {
                path: 'vendors/:id',
                name: 'vendor-view',
                component: VendorView
            }, {
                path: 'vendors/create',
                name: 'create-vendor-view',
                component: CreateVendorView
            }, {
                path: '/banks/:id/acquiring/create',
                name: 'acquiring-create',
                component: CreateAcquiringView
            }, {
                path: 'state-constructor',
                name: 'state-constructor',
                component: StateConstructorView
            }, {
                path: 'counterparties',
                name: 'counterparties',
                component: CounterpartiesView
            }, {
                path: 'counterparties/create',
                name: 'counterparty-create',
                component: CreateCounterpartyView
            }, {
                path: 'counterparties/:id',
                name: 'counterparty-edit',
                component: CounterpartyView
            }, {
                path: 'objects',
                name: 'objects',
                component: ObjectsView
            }, {
                path: 'objects',
                name: 'object-edit',
                component: ObjectView,
            },{
                path: 'partners',
                name: 'partners',
                component: PartnersView,
                children: [{
                    path: 'list',
                    name: 'partners-list',
                    component: PartnersListView
                }, {
                    path: 'categories',
                    name: 'partners-categories',
                    component: PartnerCategoriesView,
                }],
            },
                {
                    path: 'partners/add',
                    name: 'partners-create',
                    component: PartnerCreateView,
                },
                {
                    path: 'partners/:id',
                    name: 'partner-view',
                    component: PartnerView,
                }, {
                    path: 'partners/categories/:id',
                    name: 'partner-category-view',
                    component: PartnerCategoryView
                }, {
                    path: 'partners/categories/create',
                    name: 'partner-category-create',
                    component: CreatePartnerCategory
                }, {
                    path: 'profile',
                    name: 'profile',
                    component: ProfileVIew
                }, {
                    path: 'support',
                    name: 'support',
                    component: SupportView
                },{
                    path: 'personal-accounts',
                    name: 'personal-accounts',
                    component: PersonalAccounts,
                },{
                    path: 'settings',
                    name: 'settings',
                    component: SettingsView,
                },
                {
                    path: 'settings/hints/:key',
                    name: 'hints-item',
                    component: HintsItemView,
                },
                {
                    path: 'modals/add',
                    name: 'modals-add',
                    component: ModalsItemView,
                },{
                    path: 'modals/:id',
                    name: 'modals-item',
                    component: ModalsItemView,
                },
                {
                    path: 'info-page/add',
                    name: 'info-page-add',
                    component: InfoPageView,
                },{
                    path: 'info-page/:id',
                    name: 'info-page-item',
                    component: InfoPageView,
                },
                {
                    path: 'website',
                    name: 'website',
                    component: WebsiteView,
                }, {
                    path: 'website-news/add',
                    name: 'website-news-add',
                    component: CreateWebsiteNews,
                },{
                    path: 'website-news/:id',
                    name: 'website-news-item',
                    component: CreateWebsiteNews,
                },{
                    path: 'website-services/add',
                    name: 'website-services-add',
                    component: CreateWebsiteServices,
                },{
                    path: 'website-services/:id',
                    name: 'website-services-item',
                    component: CreateWebsiteServices,
                },
                {
                    path: 'website-infrastructure/add',
                    name: 'website-infrastructure-add',
                    component: WebsiteInfrastructure,
                },
                {
                    path: 'website-vacancies/add',
                    name: 'website-vacancies-add',
                    component: VacanciesItem,
                },
                {
                    path: 'website-vacancies/:id',
                    name: 'website-vacancies-item',
                    component: VacanciesItem,
                },
                {
                    path: 'vacancies/locations',
                    name: 'website-vacancies-locations',
                    component: VacanciesLocations,
                },
                {
                    path: '/vacancies/departments',
                    name: 'website-vacancies-departments',
                    component: VacanciesDepartments,
                },
                {
                    path: 'website-infrastructure/:id',
                    name: 'website-infrastructure-item',
                    component: WebsiteInfrastructure,
                },
                {
                    path: 'website-infrastructure/apartments/add',
                    name: 'apartments-category-add',
                    component: WebsiteInfrastructureCategory,
                },
                {
                    path: 'website-infrastructure/apartments/:id',
                    name: 'apartments-category',
                    component: WebsiteInfrastructureCategory,
                },
            ]),
            {
                path: 'reports',
                name: 'reports',
                component: ReportsView,
            }
        ],
    },

];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
